/**
 * StorageTraceabilityContent
 *
 * Embeddable version of the Storage Traceability table. Accepts props instead
 * of reading from router hooks, so it can be rendered inside a SmartDialog
 * without navigating away from the Warehouse Storage Manager.
 *
 * The original route-based version lives in StorageTraceability.jsx and is
 * still used by the standalone /process/storageTraceability/:storageId route.
 *
 * Backend endpoint: GET /endpoints/storageTraceability/pagination/{storageId}
 * Returns paginated history of resource movements in/out of each shelf position.
 *
 * Props:
 *   storageId    – number: the storage to query (same as the selected tab id)
 *   storageName  – string: shown as the table title
 */
import { useCallback } from 'react'
import SmartMateriaUITable from '../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { apiGet } from '../generic/Api_Functions'

export default function StorageTraceabilityContent ({ storageId, storageName }) {
  const { t_ } = useSmartTranslation()

  const columns = [
    { name: t_('Date In'), field: 'dateIn', type: 'datetime' },
    { name: t_('Date Out'), field: 'dateOut', type: 'datetime' },
    { name: t_('Shelve'), field: 'shelve', edit: false },
    { name: t_('Row'), field: 'rowNumber', edit: false },
    { name: t_('Column'), field: 'colNumber', edit: false },
    { name: t_('Resource type'), field: 'resourceType.name', edit: false },
    { name: t_('Reference code'), field: 'resourceReferenceCode', edit: false },
    { name: t_('Reference name'), field: 'resourceReferenceName', edit: false },
    { name: t_('Instance code'), field: 'resourceInstanceCode', edit: false },
    { name: t_('Instance name'), field: 'resourceInstanceName', edit: false },
    { name: t_('Fixture code'), field: 'fixtureCode', edit: false },
    { name: t_('Fabrication order'), field: 'instanceFo', edit: false }
  ]

  const dataFetch = useCallback(async (pagination) => {
    return await apiGet('storageTraceability/pagination/' + storageId, pagination)
  }, [storageId])

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='storageTraceabilityModal'
      title={storageName}
      columns={columns}
      dataFetch={dataFetch}
      pageable
      dense
      sortOptions={{ default: { field: 'dateIn', direction: -1 } }}
    />
  )
}
